import React from 'react'

import Icon from './Icon'
import type { IconProps } from './Icon'
import { ReactComponent as PriorityHigh } from 'assets/svg/icon-priority-high.svg'

function IconPriorityHigh(props: IconProps): JSX.Element {
  const title = 'icon-priority-high'
  const {
    className,
    id = title,
    name = title,
    variants = 'md',
    ...others
  } = props

  const svgProps = { id, name }

  return (
    <Icon className={className} variants={variants} {...others}>
      <PriorityHigh {...svgProps} data-testid={title} />
    </Icon>
  )
}

export default IconPriorityHigh
